import { useState, useCallback } from 'react';

type LoadingStates = { [key: string]: boolean };

export const useLoadingState = (initialState: LoadingStates = {}) => {
  const [loadingStates, setLoadingStates] = useState<LoadingStates>(initialState);

  const startLoading = useCallback((key: string) => {
    setLoadingStates(prev => ({ ...prev, [key]: true }));
  }, []);

  const stopLoading = useCallback((key: string) => {
    setLoadingStates(prev => ({ ...prev, [key]: false }));
  }, []);

  const isLoading = useCallback((key: string) => {
    return loadingStates[key] || false;
  }, [loadingStates]);

  const resetLoading = useCallback(() => {
    setLoadingStates({});
  }, []);

  return {
    startLoading,
    stopLoading,
    isLoading,
    resetLoading,
    loadingStates
  };
};

export default useLoadingState;